import { Box, styled, Typography } from '@mui/material';
import { floatAnimation, slideInLeftAnimation, slideInLeftSubtitleAnimation } from '../../utils/animation';

export const GreetingsBannerContainer = styled(Box)(() => ({
  position: 'relative',
  background:
    'linear-gradient(135deg, color-mix(in srgb, var(--color-accent) 90%, #000) 0%, color-mix(in srgb, var(--color-accent) 60%, #fff) 100%)',
  padding: '32px 24px',
  marginBottom: '24px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}));

export const GreetingsBannerPattern = styled(Box)(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundImage: `
    radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.1) 2px, transparent 2px),
    radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.05) 1px, transparent 1px),
    radial-gradient(circle at 40% 80%, rgba(255, 255, 255, 0.08) 1.5px, transparent 1.5px)
  `,
  backgroundSize: '50px 50px, 30px 30px, 40px 40px',
  animation: `${floatAnimation} 20s ease-in-out infinite`,
}));

export const GreetingsBannerGreeting = styled(Typography)(({ theme }) => ({
  color: '#fff',
  textShadow: '0 2px 4px rgba(0,0,0,0.3)',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  animation: `${slideInLeftAnimation} 0.8s ease-out`,
  fontSize: '22px',
  margin: '0 0 8px 0',
}));

export const GreetingsBannerSubtitle = styled(Typography)(() => ({
  color: '#fff',
  fontSize: '14px',
  textShadow: '0 2px 4px rgba(0,0,0,0.3)',
  animation: `${slideInLeftSubtitleAnimation} 0.8s ease-out 0.2s both`,
  margin: 0,
}));
